import React from "react";
import { Backdrop } from "@mui/material";
import { CircularProgress } from "@mui/material";

export default function LoadingLogin(props: any) {
  return (
    <div>
      <Backdrop
        sx={{
          color: "var(--color-white)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={props.open}
        onClick={props.handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
